export default __webpack_public_path__ + "static/media/youtube-icon-emBlue.b39a2fa8.svg";